import { post } from "../request";

/**
 * 获取城市区域
 * @param data
 * @returns {*}
 */
export function getRegion(data) {
  return post("admin/setting/getRegion", data);
}

/**
 * 获取系统配置
 * @param data
 * @returns {*}
 */
export function getSetting(data) {
  return post("admin/setting/getSetting", data);
}

/**
 * 设置系统配置
 * @param data
 * @returns {*}
 */
export function setSetting(data) {
  return post("admin/setting/setSetting", data);
}
/**
 * 阿里短信配置
 * @param data
 * @returns {*}
 */
export function aliyunSet(data) {
  return post("admin/setting/aliyunSet", data);
}
/*
 * 获取全国区域
 * */
export function getAreaRegion(data) {
  return post("admin/setting/getRegion", data);
}

/*
 * 获取全国区域
 * */
export function setRegion(data) {
  return post("admin/setting/setRegion", data);
}

/*
 * 获取全国区域
 * */
export function delRegion(data) {
  return post("admin/setting/delRegion", data);
}

/*
 * 获取全国区域
 * */
export function getSetRegion(data) {
  return post("admin/setting/getSetRegion", data);
}

/**
 * 设置提醒手机号
 * */
export function RemindMobileSet(data) {
  return post("admin/setting/RemindMobileSet", data);
}

/**
 * 后端获取省
 * */
export function storeRegionList() {
  return post("admin/Setting/storeRegionList");
}
/**
 * 后端获取省
 * */
export function addStoreRegion(data) {
  return post("admin/Setting/addStoreRegion", data);
}

/**
 * 获取问题
 * @param data
 * @returns {*}
 */
export function getIssue(data) {
  return post("admin/article.commonproblems/index", data);
}

/**
 * 添加问题
 * @param data
 * @returns {*}
 */
export function setAddIssue(data) {
  return post("admin/article.commonproblems/add", data);
}

/**
 * 删除问题
 * @param data
 * @returns {*}
 */
export function deleteIssue(data) {
  return post("admin/article.commonproblems/delete", data);
}

/**
 * 编辑问题
 * @param data
 * @returns {*}
 */
export function setEditIssue(data) {
  return post("admin/article.commonproblems/edit", data);
}

/**
 * 获取积分设置列表
 * @param data
 * @returns {*}
 */
export function getUserSourceConfig() {
  return post("admin/Setting/getUserSourceConfig");
}

/**
 * 设置积分设置列表
 * @param data
 * @returns {*}
 */
export function setUserSourceConfig(data) {
  return post("admin/Setting/setUserSourceConfig", data);
}

/**
 * 获取是否开启充值（含虚拟支付配置）
 */
export function getIsPay() {
  return post("admin/Setting/getIsPay");
}

/**
 * 设置是否开启充值
 */
export function setIsPay(data) {
  return post("admin/Setting/setIsPay", data);
}

/**
 * 保存虚拟支付配置
 */
export function setVirtualPayConfig(data) {
  return post("admin/Setting/setVirtualPayConfig", data);
}
